// src/App.js ou un autre composant de page
import React from 'react';
import Navbar from './components/Navbar';
import Carousel from './components/Carousel';
import Section from './components/Section';
import SectionAbout from './components/SectionAbout'; 
import SectionData from './components/SectionData';
import LocationMap from './components/LocationMap';
import FeaturesSection from './components/FeaturesSection';
import Footer from './components/Footer';

function App() {
  return (
    <div className="relative">
      <div className="fixed top-0 left-0 w-full z-20">
      <Navbar />
      </div>
      <Carousel />
      <Section />
      <SectionAbout />
      <SectionData />
      <FeaturesSection />
      <LocationMap />
      <Footer />
    </div>
  );
}

export default App;